<template>
    <div>
        <div class="grid-container">
            <form autocomplete="off" id="search-bar">
                <autocomplete-input
                    :label="$t('transfer.from')"
                    :value="beClear ? '' : from.label"
                    @change="showEfectsFrom"
                    @blur="handleBlur"
                />

                <autocomplete-input
                    :iconDefault="false"
                    :label="$t('transfer.to')"
                    :value="beClear ? '' : to.label"
                    @change="showEfectsTo"
                    @blur="handleBlur"
                />
                <div>
                    <intl-tel
                        ref="intlTel"
                        :label="$t('transfer.phoneNumber')"
                        :value="
                            !isLogged
                                ? phoneNumber
                                : this.currentPassenger.phonenumber
                        "
                        :showErrors="true"
                        :error="phoneNumber == '' && isMarkedPhoneInput"
                        v-on:change="showEfects"
                        :disabled="isLogged"
                        @focus="focusIntlTel"
                    />
                    <small
                        v-if="phoneNumber == '' && isMarkedPhoneInput"
                        style="color:red; padding-bottom: 10px;"
                        >Wpisz numer telefonu</small
                    >
                </div>

                <md-card-content>
                    <div class="form-in-line" style="width:100%;">
                        <div class="input-padding">
                            <label class="pure-material-textfield-outlined">
                                <input
                                    class="datapicker"
                                    placeholder=" "
                                    type="date"
                                    v-model="date"
                                    min="2022-06-02"
                                    style="height: 3.275rem;"
                                />
                                <span
                                    >{{ $t('transfer.dateOfDeparture') }}
                                </span>
                            </label>
                        </div>

                        <div class="select-padding">
                            <label class="pure-material-textfield-outlined">
                                <select
                                    placeholder=" "
                                    name="cars"
                                    id="cars"
                                    v-model="passengers"
                                >
                                    <option v-for="n in 8" :key="n">{{
                                        n
                                    }}</option>
                                </select>
                                <span>{{ $t('transfer.passengers') }}</span>
                            </label>
                        </div>
                    </div>
                </md-card-content>
            </form>
            <div id="attributes-picker">
                <div id="more" @click="showMoreOptins">
                    {{ $t('components.additionalOptions') }}
                    <div
                        :class="{
                            'triangle-up': showAttributes,
                            'triangle-down': !showAttributes
                        }"
                    />
                </div>

                <div class="checkboxes mt5" :class="{ active: showAttributes }">
                    <div v-for="(item, index) in attributes" :key="index">
                        <ul v-if="index > 0" class="list-transfer">
                            <div class="subtitle">
                                <div>
                                    <img
                                        :src="
                                            require(`@assets/images/${
                                                arrayOfIcons[index - 1].icon
                                            }`)
                                        "
                                        :alt="$t(arrayOfIcons[index - 1].info)"
                                    />
                                    {{ $t(arrayOfIcons[index - 1].info) }}
                                </div>
                            </div>
                            <md-switch v-model="attributes[index]" />
                        </ul>
                        <md-divider class="md-inset" />
                    </div>
                </div>

                <md-card-content class="center">
                    <md-button
                        v-if="depositButton && !beClear"
                        class="card-call-btn btn-default-blue button"
                        @click="$emit('showAdvanceModal')"
                    >
                        <img
                            :src="require('@assets/images/ticket.svg')"
                            style="margin-top:1px;"
                            alt="Zaliczka"
                            title="Zaliczka"
                        />
                        <div style="padding-right: 23px" class="uppercase">
                            &nbsp;{{ $t('route.deposit') }}
                        </div>
                    </md-button>

                    <md-button
                        v-else
                        ng-disabled="true"
                        class="card-call-btn btn-default-blue button"
                        :class="{'disabled-background':!isValidPhoneNumber}"
                        @click="()=>{isValidPhoneNumber?submit():''}"
                    >
                        <img v-if="!loading" style="display:none" />
                        <img
                            v-if="loading"
                            :src="require('@assets/images/loader.gif')"
                            alt="Zaliczka"
                            title="Zaliczka"
                        />
                        <div v-if="!loading" class="uppercase">
                            &nbsp;{{ sendButton }}
                        </div>
                    </md-button>
                </md-card-content>
            </div>
        </div>
        
        <div v-if="isSpectrum">
            <div v-if="!loading && send" class="info-text c9c9c9c">
                {{ $t('components.sendSmsToCarriersDescription') }}
            </div>
            <div v-else-if="!loading && isMarkedPhoneInput" class="info-text c9c9c9c">{{ $t('components.whyDoINeedToLeavePhoneNumber') }}</div>
        </div>
       <div v-else-if="!isTaken" class="info-text c9c9c9c">{{$t('components.afterSendRequestInfoMessage')}}</div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
import attributesIcons from '@assets/arrayOfAttributesIcons';
import AutocompleteInput from '../components/AutocompleteInput';
import '@matthew2097/intl-tel-material';
import countries from '@assets/countries';

export default {
    components: {
        AutocompleteInput
    },

    props: {
        getQueryParams: {
            type: Boolean,
            default: false
        },

        isSpectrum: {
            type: Boolean,
            default: false
        },

        depositButton: {
            type: Boolean,
            default: true
        },

        routeDetails: {
            type: Object,
            default: {}
        },

        clear: {
            type: Boolean,
            default: false
        },
        isTaken:{
            type:Boolean,
            default:false
        }
    },

    data() {
        return {
            isValidPhoneNumber:false,
            queryParams: false,
            phoneNumber: '',
            beClear: false,
            default: true,
            showAttributes: false,
            countyError: false,
            passengers: 1,
            from: {},
            to: {},
            date: moment().format('YYYY-MM-DD'),
            attributes: [1, 0, 0, 0, 0, 0, 0, 0],
            arrayOfIcons: attributesIcons,
            loading: false,
            send: false
        };
    },

    watch: {
        routeDetails(e) {
            if (!!Object.entries(e).length) {
                this.from.label = e.from;
                this.to.label = e.to;
                this.attributes = this.convertToBoolean(e.attributes);
                this.date = moment(e.requested_at).format('YYYY-MM-DD');
                this.passengers = e.count;
            }
        },

        clear(e) {
            if (e) {
                this.clearForms();
            }
        }
    },

    computed: {
        ...mapGetters({
            currentPassenger: 'auth/currentPassenger',
            isLogged: 'auth/loggedInAsPassenger',
            isMarkedPhoneInput: 'global/isMarkedPhoneInput'
        }),

        sendButton() {
            if (this.isSpectrum && this.isLogged) {
                return this.$t('route.sendDeposit');
            }

            if (this.beClear) {
                return this.$t('settings.change');
            } else {
                return this.$t('route.sendDeposit');
                // return this.send
                //     ? this.$t('route.sendDeposit')
                //     : this.$t('components.find');
            }
        }
    },

    methods: {
        ...mapActions({
            searchCarriers: 'flotea/searchCarriers',
            autocomplete: 'flotea/autocomplete',
            search: 'flotea/search',
            postalCode: 'flotea/postalCode',
            sendPassenger: 'flotea/sendPassenger',
            verifyPhoneNumber: 'auth/loginByPhoneNumberAsPassenger',
            loginByRequestAsPassenger: 'auth/loginByRequestAsPassenger'
        }),

        ...mapMutations({
            setMarkedPhoneInput: 'global/SET_MARKED_PHONE_INPUT'
        }),

        focusIntlTel(e) {
            this.$refs.intlTel.value = '';
        },

        handleBlur(e) {
            if (this.depositButton && !this.beClear) {
                this.clearForms();
            }
        },

        convertToBoolean(value) {
            return value.map((item, index) => {
                if (index) {
                    return item === 1 ? true : false;
                } else {
                    return item;
                }
            });
        },

        showMoreOptins() {
            this.showAttributes = !this.showAttributes;
        },

        formatDate(currentDate, format) {
            const map = {
                mm: ('0' + (currentDate.getMonth() + 1)).slice(-2),
                dd: ('0' + currentDate.getDate()).slice(-2),
                yyyy: currentDate.getFullYear()
            };

            return format.replace(/mm|dd|yyyy/gi, matched => map[matched]);
        },

        showEfects(e) {
            const { isValid, value } = e.detail;
            this.isValidPhoneNumber = isValid;
            this.phoneNumber = value;
            this.setMarkedPhoneInput(false);

            if (!this.isLogged && isValid) {
                this.send = true;
            } else {
                this.send = false;
            }
        },

        showEfectsFrom(e) {
            this.from = e;
        },

        showEfectsTo(e) {
            this.to = e;
        },

        clearForms() {
            this.beClear = true;
            this.from = {};
            this.to = {};
            this.attributes = [1, 0, 0, 0, 0, 0, 0, 0];
            this.passengers = 1;
            this.date = moment().format('YYYY-MM-DD');
        },

        isValid() {
            const { from, to, queryParams } = this;

            if (queryParams) {
                return true;
            }

            if (from.isValid && to.isValid) {
                return true;
            } else {
                return false;
            }
        },

        async searchResults(update = true) {
            this.loading = true;
            const { from, to } = this;
            const params = {
                expand: 'userVoip',
                date: moment(this.date).format('YYYY-MM-DD'),
                from_lat: from.lat,
                from_lng: from.lng,
                from_country: countries[from.county],
                place_from: from.name,
                from_locality: from.name,
                from_administrative_area_level_1: from.region,
                from_administrative_area_level_2: from.name,
                from_administrative_area_level_3: from.name,
                to_lat: to.lat,
                to_lng: to.lng,
                to_country: countries[to.county],
                to_administrative_area_level_1: to.region,
                to_administrative_area_level_2: to.name,
                to_administrative_area_level_3: to.name,
                place_to: to.name,
                to_locality: to.name,
                'datepicker-min-max': moment(this.date).format('YYYY-MM-DD'),
                phone: '',
                from_natural_feature: '',
                to_natural_feature: ''
            };

            const { connections: response } = await this.searchCarriers(params);

            if (update) {
                const passenger = this.getPassenger(true);
                localStorage.spectrum = JSON.stringify(passenger);
            }

            if (response) {
                this.$emit('response', response);
                this.$emit('destination', {
                    from: params.place_from,
                    to: params.place_to
                });
            }

            this.loading = false;
        },

        getPassenger(full = false) {
            const attributes = this.attributes.map(x => {
                return x === true ? 1 : 0;
            });

            attributes[0] = parseInt(this.passengers);

            let email = '';
            let partner = '';
            let parsedSpectrum;
            const spectrum = localStorage.spectrum;

            if (spectrum) {
                parsedSpectrum = JSON.parse(spectrum);
            }

            if (
                (parsedSpectrum && parsedSpectrum.partner !== '') ||
                (parsedSpectrum && parsedSpectrum.email !== '')
            ) {
                email = parsedSpectrum.email;
                partner = parsedSpectrum.partner;
            }

            if (!full) {
                return {
                    passenger: [
                        {
                            count: parseInt(this.passengers),
                            phone: this.phoneNumber,
                            city_from: this.from.label,
                            pos_from: {
                                lat: this.from.lat,
                                lng: this.from.lng
                            },
                            city_to: this.to.label,
                            pos_to: {
                                lat: this.to.lat,
                                lng: this.to.lng
                            },
                            attributes,
                            when: moment(this.date).format('YYYY-MM-DD')
                        }
                    ]
                };
            } else {
                return {
                    attributes,
                    date: moment(this.date).format('YYYY-MM-DD'),
                    from_lat: this.from.lat,
                    from_lng: this.from.lng,
                    from_country: this.from.county,
                    place_from: this.from.name,
                    from_region: this.from.region,
                    from_postal: this.from.postal,
                    to_lat: this.to.lat,
                    to_lng: this.to.lng,
                    to_country: this.to.county,
                    place_to: this.to.name,
                    to_region: this.to.region,
                    to_postal: this.to.postal,
                    email,
                    partner
                };
            }
        },

        async loginBeforeSend(passenger, uuid) {
            const response = await this.loginByRequestAsPassenger({
                route_uid: uuid,
                phone: this.phoneNumber
            });

            if (!response) {
                this.$toast.error(this.$t('auth.unauthorized'));
                return;
            }

            const request = await this.sendPassenger(passenger);
            this.showToast(request);
        },

        async submit(update = true) {
            if (!this.isValid()) {
                this.$toast.error(this.$t('transfer.completeForms'));

                return;
            }

            if (this.from.county === this.to.county) {
                this.countyError = true;

                this.$toast.error(
                    this.$t(
                        'transfer.departureAndArrivalFromDifferentCountries'
                    )
                );

                return;
            }

            if (!this.isValidPhoneNumber && this.phoneNumber !== '') {
                this.$toast.error(this.$t('transfer.enterValidPhone'));

                return;
            }

            if (this.phoneNumber === '') {
                this.setMarkedPhoneInput(true);
                this.searchResults(update);

                return;
            }

            const params = this.getPassenger();

            const { passenger } = params;

            if (this.email && this.partner) {
                passenger[0].email = this.email;
                passenger[0].partner = this.partner;
            }

            if (!this.isLogged) {
                const responseVerifyPhone = await this.verifyPhoneNumber(
                    this.phoneNumber
                );

                localStorage.spectrum = JSON.stringify(this.getPassenger(true));
                localStorage.passenger = JSON.stringify(params);

                if (responseVerifyPhone.isVerified) {
                   
                    const { requestUUID } = responseVerifyPhone;
                    this.loginBeforeSend(params, requestUUID);
                    return;
                }

                this.$router.push(`/login/check-pin?redirectFrom=/spectrum`);

                return;
            }

    

            const response = await this.sendPassenger(params);

            if (response.request_uuid && this.isLogged) {
                localStorage.lastRequest = response.request_uuid;
                this.$router.push(`/app/${response.request_uuid}`);
            }

            this.showToast(response);
        },

        showToast(response){

            if (response.valid) {
                localStorage.lastRequest = response.request_uuid;
                localStorage.removeItem('spectrum');
                this.$router.push(`/app/${response.request_uuid}`);
                this.$toast.success(
                    this.$t('transfer.passengerHasBeenHandedOver')
                );
                this.clearForms();
                return;
            }

            switch (response.errors[0]) {
                case 'Multiple requests are locked. Update success.':
                    this.beClear?this.$toast.success("Trasa została zmianiona"):this.$toast.error(this.$t('components.nextRequestMessage'));
                break;
                case `You cannot select date backward [${this.date}]`:
                    this.date = moment().format('YYYY-MM-DD');
                    this.$toast.info(this.$t('transfer.reverseDate'));
                break;
                default:
                this.$toast.error(this.$t('global.somethingWrong'));
            }

            if (response.request_uuid) {
                this.$router.push(`/app/${response.request_uuid}`);
            }
        },

        loadDataFromQuery(query) {
            const {
                attributes,
                from_lat,
                from_lng,
                from_country,
                place_from,
                from_region,
                from_postal,
                to_lat,
                to_lng,
                to_country,
                place_to,
                to_region,
                to_postal,
                email,
                partner
            } = query;

            this.email = email;
            this.partner = partner;
            this.attributes = this.convertToBoolean(attributes);
            this.queryParams = true;
            this.date = query.date;
            this.from = {
                label: from_postal + ' ' + place_from,
                name: place_from,
                lat: parseFloat(from_lat),
                lng: parseFloat(from_lng),
                county: from_country,
                postal: from_postal,
                region: from_region
            };

            this.to = {
                label: to_postal + ' ' + place_to,
                name: place_to,
                lat: parseFloat(to_lat),
                lng: parseFloat(to_lng),
                county: to_country,
                postal: to_postal,
                region: to_region
            };

            this.submit(false);
        }
    },

    mounted() {
        const spectrum = localStorage.getItem('spectrum');

        try {
            const parsedSpectrum = JSON.parse(spectrum);
            if (parsedSpectrum && this.$route.name !== 'passenger') {
                this.loadDataFromQuery(parsedSpectrum);
            }
        } catch (error) {
            console.log(error);
        }

        if (!this.isLogged) {
            this.$refs.intlTel.value = this.$t(
                'components.labelEnterYourPhone'
            );
        }
    }
};
</script>

<style scoped>
.md-card-content {
    display: flex;
    padding: 3px 0px;
}
.autocomplete-list {
    margin-left: 0;
    margin-right: 0;
}

.button {
    width: 85%;
    margin-left: 10px;
    background: #4558de;
    height: 50px;
}

@media only screen and (max-width: 550px) {
    .button {
        width: 100% !important;
        left: -5px;
    }
}

.info-text {
    padding: 0px 16px 16px 16px;
}
</style>
